<div [class]="'theme-wrapper ' + 'default-theme'">
  <mat-sidenav-container>
    <mat-sidenav #sidenav mode="push">
      <div class="branding">
        <span>{{ 'tcd.title.short' | translate }}</span>
      </div>
      <mat-nav-list>
        @for (item of navigationSideMenu; track item) {
          <a
            mat-list-item
            (click)="sidenav.close()"
            [routerLink]="[item.link]"
            routerLinkActive="list-item-active"
          >
            {{ item.label | translate }}
          </a>
        }
      </mat-nav-list>
    </mat-sidenav>

    <div class="wrapper">
      <div class="toolbar">
        <nav class="navbar navbar-expand-md">
          <button
            mat-icon-button
            class="d-md-none"
            (click)="sidenav.open()"
          ></button>

          <span routerLink="" class="branding center d-inline d-sm-none">
            <fa-icon class="icon-action fa-lg" [icon]="faBars"></fa-icon>
          </span>

          <span
            routerLink=""
            class="branding center d-none d-sm-inline d-md-none"
          >
            {{ 'tcd.title.short' | translate }}
          </span>

          <span routerLink="" class="branding d-none d-md-inline">
            <!-- <img alt="logo"
            [src]="logo" /> -->
            {{ 'tcd.title.long' | translate }}
          </span>

          <div class="collapse navbar-collapse">
            <ul class="navbar-nav ml-3 mr-auto">
              @for (e of examples; track e) {
                <li class="nav-item">
                  <a
                    [routerLink]="e.link"
                    [ngClass]="{ 'active navigate-active': rla.isActive }"
                    routerLinkActive="is-Active"
                    #rla="routerLinkActive"
                  >
                    {{ e.label | translate }}
                  </a>
                </li>
              }
            </ul>
          </div>

          <span class="spacer"></span>

          <button
            type="button"
            mat-icon-button
            aria-label="logOut"
            class="d-sm-inline mr-3"
            (click)="onLogoutClick()"
          >
            <fa-icon class="icon-action fa-lg" [icon]="faLogout"></fa-icon>
          </button>
        </nav>
      </div>

      <div class="content" [@routeAnimations]="o.isActivated">
        <router-outlet #o="outlet"></router-outlet>
      </div>

      <div class="footer">
        <div class="row">
          <div class="col-12 signature">
            <span [style.color]="usingMockData ? '#f00' : '#000'"
              >&#169; {{ year }} - TUI - Version: {{ version }}</span
            >
            <br class="d-block d-sm-none" />
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>
